import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { promotionalBannerQueries } from '@/services/promotionalBanner/promotionalBanner.queries';

export const usePromotionalBannerDetail = ({ promotionId }: { promotionId: string }) => {
  const { data, isLoading } = useQuery({
    ...promotionalBannerQueries.detail({
      promotionId,
    }),
    enabled: !!promotionId,
  });

  return {
    promotionalBanner: data?.data,
    isLoading,
  };
};
